<template>
  <div>
    <h3 class="h3-responsive">Багцын бүртгэлийн жагсаалт</h3>
    <Toast position="bottom-right" />

    <!-- configration dialog -->
    <Dialog
      header="Анхааруулга"
      :visible.sync="displayDelete"
      :style="{ width: '505px' }"
      :modal="true"
    >
      <template #header></template>
      <div class="confirmation-content">
        <i
          class="pi pi-exclamation-triangle p-mr-3"
          style="font-size: 2rem; margin-right: 0.5em; color: red"
        />
        <span
          >Та {{ this.packageId }} дугаартай багцыг устгахдаа итгэлтэй байна уу
          ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Үгүй"
          icon="pi pi-times"
          @click="actionDialog('no', null)"
          class="p-button-danger p-button-text"
        />
        <Button
          label="Тийм"
          icon="pi pi-check"
          @click="actionDialog('yes', null)"
          class="p-button-danger p-button-text"
          autofocus
        />
      </template>
    </Dialog>
    <!-- diaglog for register and update contract -->
    <Dialog
      :visible.sync="displayModal"
      :style="{ width: '70vw' }"
      :modal="true"
    >
      <template #header>
        <h3 class="h3-responsive">{{ modalTitle }}</h3>
        <div class="form-group">
          <label for="packageId">Багцын дугаар:</label>
          <InputText
            id="packageId"
            type="text"
            ref="contractInput"
            placeholder="Багцын дугаар №"
            class="form-control"
            v-model.trim="$v.packageId.$model"
            :class="{
              'is-invalid': $v.packageId.$error,
              'is-valid': !$v.packageId.$invalid,
            }"
            :disabled="contractDisabled == 1"
            :autofocus="IsFocus"
          />
          <div class="valid-feedback">Багцын дугаар оруулсан!</div>
          <div class="invalid-feedback">
            <span v-if="!$v.packageId.required">Багцын дугаар оруулна уу.</span>
            <span v-if="!$v.packageId.minLength">
              Багцын дугаар доод тал нь
              {{ $v.packageId.$params.minLength.min }} тэмдэг байх ёстой.</span
            >
            <span v-if="!$v.packageId.maxLength">
              Багцын дугаар дээд тал нь
              {{ $v.packageId.$params.maxLength.max }} тэмдэг байх ёстой.</span
            >
            <span v-if="!$v.packageId.numeric"
              >Зөвхөн тоон утаг оруулна уу.</span
            >
          </div>
        </div>
      </template>

      <div class="p-grid">
        <div class="p-col">
          <h5 class="h5-responsive">Багцын мэдээлэл:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="type">Төрөл:</label>
              <InputText
                id="type"
                type="text"
                class="form-control"
                v-model.trim="$v.type.$model"
                :class="{
                  'is-invalid': $v.type.$error,
                  'is-valid': !$v.type.$invalid,
                }"
                :disabled="disabled == 1"
                :autofocus="IsParents"
              />
              <div class="valid-feedback">Төрөл оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.type.required"> Төрөлийг оруулна уу.</span>       
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="data">Дата:</label>
                <InputText
                  id="data"
                  type="text"
                  v-model.trim="$v.data.$model"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.data.$error,
                    'is-valid': !$v.data.$invalid,
                  }"
                  :disabled="disabled == 1"
                />
              <div class="valid-feedback">Дата оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.data.required">Дата оруулна уу.</span>
                <span v-if="!$v.data.numeric">Зөвхөн тоон утаг оруулна уу.</span>
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="unit">Нэгж:</label>
                <InputText
                  id="unit"
                  type="text"
                  v-model.trim="$v.unit.$model"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.unit.$error,
                    'is-valid': !$v.unit.$invalid,
                  }"
                  :disabled="disabled == 1"
                />
              <div class="valid-feedback">Нэгж оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.unit.required">Нэгж оруулна уу.</span>
                <span v-if="!$v.unit.numeric">Зөвхөн тоон утаг оруулна уу.</span>
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="speed">Интернэтийн хурд</label>
                <InputText
                  id="speed"
                  type="text"
                  v-model.trim="$v.speed.$model"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.speed.$error,
                    'is-valid': !$v.speed.$invalid,
                  }"
                  :disabled="disabled == 1"
                />
              <div class="valid-feedback">Интернэтийн оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.speed.required">Интернэтийн оруулна уу.</span>
                <span v-if="!$v.speed.numeric">Зөвхөн тоон утаг оруулна уу.</span>
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="monthlyPayment">Сарын суурь хураамж:</label>
              <InputText
                id="monthlyPayment"
                type="text"
                v-model.trim="$v.monthlyPayment.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.monthlyPayment.$error,
                  'is-valid': !$v.monthlyPayment.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Сарын суурь хураамж оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.monthlyPayment.required">Сарын суурь хураамж оруулна уу.</span>
                <span v-if="!$v.monthlyPayment.numeric">Зөвхөн тоон утаг оруулна уу.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="Үгүй"
          icon="pi pi-times"
          class="p-button-danger p-button-text"
          @click="actionModal('no', null)"
        />
        <Button
          label="Хадгалах"
          type="submit"
          icon="pi pi-save"
          class="p-button-success"
          @click="actionModal('save', null)"
          v-show="!viewMode && !viewEdit"
        />
        <Button
          label="Шинэчлэх"
          icon="pi pi-save"
          class="p-button-warning"
          @click="actionModal('update', null)"
          v-show="viewEdit"
          :autofocus="viewEdit"
        />
      </template>
    </Dialog>
    <DataTable
      :value="packages"
      :filters="filters"
      :paginator="true"
      :rows="5"
      :rowsPerPageOptions="[5, 10, 20]"
      :loading="loading"
      class="p-datatable-sm"
    >
      <template #header>
        <div class="p-grid">
          <div class="p-col">
            <div class="box">
              <Button
                label="Багцын бүртгэл"
                class="p-button-success"
                icon="pi pi-plus"
                style="margin: 4px 4px 0px 0px"
                @click="actionModal('new', null)"
              />
            </div>
          </div>
          <div class="p-col" style="text-align: right">
            <div class="box">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  placeholder="Хайлт...."
                  size="40"
                  v-model="filters['global']"
                />
              </span>
            </div>
          </div>
        </div>
      </template>
      <template #empty>Багц олдсонгүй.</template>
      <template #loading
        >Багцын мэдээллийг ачаалж байна. Түр хүлээнэ үү.</template
      >
      <Column selectionMode="single" headerStyle="width: 3em"></Column>
      <Column field="Id" header="Багцын №" headerStyle="width: 10em">
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.Id }}</span>
        </template>
        <template #filter>
          <div class="sizes">
            <InputText
              type="text"
              v-model="filters['Id']"
              class="p-column-filter p-inputtext-sm"
              placeholder="ID-гаар хайх"
              style="width: 10em"
            />
          </div>
        </template>
      </Column>
      <Column field="Type" header="Төрөл" headerStyle="width: 10em">
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.Type }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            v-model="filters['Type']"
            class="p-column-filter p-inputtext-sm"
            placeholder="Төрлөөр хайх"
            style="width: 10em"
          />
        </template>
      </Column>
      <Column
        field="Data"
        header="Дата"
        headerStyle="width: 10em"
      >
        <template #body="slotProps"> {{ slotProps.data.Data }}GB </template>
      </Column>
      <Column
        field="Unit"
        header="Нэгж"
        headerStyle="width: 10em"
      >
        <template #body="slotProps">
          {{ formatUnit(slotProps.data.Unit) }}
        </template>
      </Column>
      <Column
        field="Speed"
        header="N-хурд"
        headerStyle="width: 10em"
      >
        <template #body="slotProps"> {{ slotProps.data.Speed }}Mbps </template>
      </Column>
      <Column field="MonthlyPayment" header="Сарын суурь хураамж">
        <template #body="slotProps">
          {{ formatCurrency(slotProps.data.MonthlyPayment) }}
        </template>
      </Column>
      <Column
        headerStyle="width: 25em; text-align: center"
        bodyStyle="text-align: center"
      >
        <template #header>
          <Button type="button" icon="pi pi-cog"></Button> </template
        >,
        <template #body="slotProps">
          <Button
            label="харах"
            type="button"
            icon="pi pi-eye"
            class="p-button-primery"
            style="margin-right: 0.5em"
            @click="actionModal('view', slotProps.data)"
          ></Button>
          <Button
            label="засах"
            type="button"
            icon="pi pi-pencil"
            class="p-button-warning"
            style="margin-right: 0.5em"
            @click="actionModal('edit', slotProps.data)"
          ></Button>
          <Button
            label="устгах"
            type="button"
            icon="pi pi-trash"
            class="p-button-danger"
            @click="actionDialog('open', slotProps.data.Id)"
          ></Button>
        </template>
      </Column>
      <template #footer
        >Нийт {{ packages ? packages.length : 0 }} багц байна.</template
      >
    </DataTable>
  </div>
</template>

<script>
import axios from "axios";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toast from "primevue/toast";
import Dialog from "primevue/dialog";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";

const baseURL = "http://localhost:8080/package";

export default {
  name: "FormValidation",
  components: {
    DataTable,
    Column,
    Button,
    InputText,
    Toast,
    Dialog,
  },
  data() {
    return {
      maxId: "",
      packageId: "",
      modalTitle: "",
      packages: [],
      errors: [],
      filters: {},
      loading: true,
      displayDelete: false,
      displayModal: false,
      viewMode: false,
      viewEdit: false,
      type: "",
      data: null,
      unit: null,
      speed: null,
      monthlyPayment: null,
      disabled: 0,
      IsFocus: false,
      IsParents: false,
      open: false,
    };
  },
  validations: {
    packageId: {
      required,
      numeric,
      minLength: minLength(1),
      maxLength: maxLength(4),
    },
    type: {
      required,
    },
    data: {
      required,
      numeric
    },
    unit: {
      required,
      numeric
    },
    speed: {
      required,
      numeric
    },
    monthlyPayment: {
      required,
      numeric
    },
  },
  async created() {
    try {
      const requestOne = axios.get(baseURL); //get contract list with Y != IsDeleted
      const requestTwo = axios.get(baseURL + "/maxId"); //get maxId

      await axios
        .all([requestOne, requestTwo])
        .then(
          axios.spread((...responses) => {
            const responseOne = responses[0];
            const responseTwo = responses[1];
            // use/access the results
            this.packages = responseOne.data;
            this.maxId = responseTwo.data;
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
      this.loading = false;
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    formatUnit(value) {
      return value.toLocaleString({ style: "currency" });
    },
    formatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "MNT",
      });
    },
    async actionDialog(condition, id) {
      if (condition == "open") {
        this.packageId = id;
        this.displayDelete = true;
      } else {
        if (condition == "yes") {
          // delete contract by Id
          const res = await axios.delete(baseURL + "/" + this.packageId);
          if (res.status == 200) {
            const resData = await axios.get(baseURL);
            this.packages = resData.data;
            this.$toast.add({
              severity: "error",
              summary: "Амжилттай устгасан",
              detail: "" + this.packageId + "",
              life: 3000,
            });
          }
        }
        this.displayDelete = false;
      }
    },
    async actionModal(type , item) {
      if (type == "new") {
        //add new Contract to the database
        if (this.maxId == null) this.IsFocus = true;
        else this.IsParents = true;
        this.packageId = (+this.maxId + +"1");
        this.contractDisabled = 0;
        this.disabled = 0;
        this.modalTitle = "Багц бүртгэлийн горим";
        this.displayModal = true;
        this.viewEdit = false;
        this.viewMode = false;
        this.type = "";
        this.data = null;
        this.unit = null;
        this.speed = null;
        this.monthlyPayment = null;
      } else if (type == "save") {        
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: "error",
            summary: "Шаардлагатай талбаруудыг бөглөнө үү",
            detail: "",
            life: 3000,
          });
        }
        //check packageId whether exist in database or not
        else if (this.packageId != null) {
          // check existing contract id
          const res = await axios.get(baseURL + "/checkId/" + this.packageId); 
          
          if (res.data.length >= 1) {
            this.$toast.add({
              severity: "warn",
              summary: "Багцын дугаарыг өөрчилнө үү.",
              detail:
                "" +
                this.packageId +
                " дугаартай багц аль хэдийн бүртгэгдсэн байна !",
              life: 3000,
            });
            this.IsFocus = true;
          } else {
            const res = await axios.post(baseURL + "/add", {
              id: this.packageId,
              type: this.type,
              data: this.data,
              unit: this.unit,
              speed: this.speed,
              monthlyPayment: this.monthlyPayment
            });

            if (res.status == 200) {
              const requestOne = axios.get(baseURL); //get contract list with Y != IsDeleted
              const requestTwo = axios.get(baseURL + "/maxId"); //get maxId

              await axios
                .all([requestOne, requestTwo])
                .then(
                  axios.spread((...responses) => {
                    const responseOne = responses[0];
                    const responseTwo = responses[1];
                    // use/access the results
                    this.packages = responseOne.data;
                    this.maxId = responseTwo.data;
                  })
                )
                .catch((errors) => {
                  console.log(errors);
                });
               
              this.modal = false;
              this.displayModal = false;
              this.viewMode = false;
              this.$toast.add({
                severity: "success",
                summary: "Амжилттай хадгалагдсан",
                detail: "",
                life: 3000,
              });
            }
          }
        }
      } else if (type == "view") {
        this.IsFocus = false;
        this.viewEdit = false;
        this.viewMode = true;
        this.contractDisabled = 1;
        this.disabled = 1;
        this.modalTitle = "Багц харах горим";
        this.packageId = item.Id;
        this.type = item.Type;
        this.data = item.Data;
        this.unit = item.Unit;
        this.speed = item.Speed;
        this.monthlyPayment = item.MonthlyPayment;
        this.displayModal = true;
      } else if (type == "edit") {
        this.IsFocus = false;
        this.viewEdit = true;
        this.viewMode = false;
        this.contractDisabled = 1;
        this.disabled = 0;
        this.modalTitle = "Багц засварын горим";
        this.packageId = item.Id;
        this.type = item.Type;
        this.data = item.Data;
        this.unit = item.Unit;
        this.speed = item.Speed;
        this.monthlyPayment = item.MonthlyPayment;
        this.displayModal = true;
      } else if (type == "update") {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: "error",
            summary: "Шаардлагатай талбаруудыг бөглөнө үү",
            detail: "",
            life: 3000,
          });
        } else {
          const res = await axios.put(baseURL + "/" + this.packageId, {
            type: this.type,
            data: this.data,
            unit: this.unit,
            speed: this.speed,
            monthlyPayment: this.monthlyPayment,
          });

          if (res.status == 201) {
            const resData = await axios.get(baseURL);
            this.packages = resData.data;
            this.modal = false;
            this.displayModal = false;
            this.viewMode = false;
            this.$toast.add({
              severity: "warn",
              summary: "Амжилттай шинэчлэгдсэн",
              detail: "" + this.packageId + "",
              life: 3000,
            });
          }
        }
      } else this.displayModal = false;
    },
  },
};
</script>